import React from 'react';
import styled from 'styled-components';

const FormError = (props) => {
  const { touch, error } = props;
  if (touch && error) {
    return <ErrorStyles>{error}</ErrorStyles>;
  }
  return null;
};

const ErrorStyles = styled.p`
  font-size: var(--font-size-sm);
  color: var(--red);
  margin-top: 5px;
`;

export default FormError;
